// extracted by mini-css-extract-plugin
export var activeSeeMore = "PricingCal-module--activeSeeMore--b33bc";
export var calculator = "PricingCal-module--calculator--dd5e1";
export var discountDesc = "PricingCal-module--discountDesc--ab369";
export var disicon = "PricingCal-module--disicon--94c1b";
export var form = "PricingCal-module--form--c2388";
export var icon = "PricingCal-module--icon--08ae1";
export var input = "PricingCal-module--input--a32b3";
export var inputWrapper = "PricingCal-module--inputWrapper--36264";
export var label = "PricingCal-module--label--0b49c";
export var paymentInfo = "PricingCal-module--paymentInfo--40abb";
export var pricingInfoWrapper = "PricingCal-module--pricingInfoWrapper--32e07";
export var pricingItem = "PricingCal-module--pricingItem--94c24";
export var pricingWrapper = "PricingCal-module--pricingWrapper--54e49";
export var radioButton = "PricingCal-module--radioButton--df219";
export var radioButtons = "PricingCal-module--radioButtons--f6b43";
export var radioInput = "PricingCal-module--radioInput--2a9ac";
export var radioMark = "PricingCal-module--radioMark--bd68d";
export var radioWrapper = "PricingCal-module--radioWrapper--addbd";
export var rtext = "PricingCal-module--rtext--1d417";
export var seeMore = "PricingCal-module--seeMore--e30ec";
export var warning = "PricingCal-module--warning--a7925";